import { render, staticRenderFns } from "./DownloadProperty.vue?vue&type=template&id=5d9765ed&scoped=true"
import script from "./DownloadProperty.vue?vue&type=script&lang=js"
export * from "./DownloadProperty.vue?vue&type=script&lang=js"
import style0 from "./DownloadProperty.vue?vue&type=style&index=0&id=5d9765ed&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9765ed",
  null
  
)

export default component.exports